import React from "react";
import { SidebarIcons } from "../../StandardContentSidebar/SidebarIcons";


const taskmanagementmenus = [
  {
    id: 8,
    label: "Task Management",
    uri: "task-management",
    type: "collapsible",
    icon: SidebarIcons.TaskManagementIcon,
    color: "#4B4B4B",
    children: [
      {
        id: 17,
        uri: `task/list-task`,
        label: "List Task",
        type: "nav-item",
        icon: SidebarIcons.ListTaskIcon,
        color: "#4B4B4B",
      },
      {
        id: 18,
        uri: `task/calendar-view`,
        label: "Task Calendar View",
        type: "nav-item",
        icon: SidebarIcons.TaskCalendarIcon,
        color: "#4B4B4B",
      },

    ],
  },

];

export default taskmanagementmenus;